import { render, staticRenderFns } from "./StudioSummary.vue?vue&type=template&id=43a3980c"
import script from "./StudioSummary.vue?vue&type=script&lang=js"
export * from "./StudioSummary.vue?vue&type=script&lang=js"
import style0 from "./StudioSummary.vue?vue&type=style&index=0&id=43a3980c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports